<template>
  <el-row :gutter="15" type="flex" justify="center">
    <el-col :span="24">
      <el-row :gutter="15" class="my-2">
        <el-col :span="24" class="border-b">
          <span class="font-semibold">INFORMACION GENERAL</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="8">
          <span class="font-semibold">Primer nombre</span>
          <p>{{ form !== null ? form.general.name1 : '' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Segundo nombre</span>
          <p>{{ form !== null ? form.general.name2 : '' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Tercer nombre</span>
          <p>{{ form !== null ? form.general.name3 : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="8">
          <span class="font-semibold">Primer apellido</span>
          <p>{{ form !== null ? form.general.lastname1 : '' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Segundo apellido</span>
          <p>{{ form !== null ? form.general.lastname2 : '' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Apellido de casada</span>
          <p>{{ form !== null ? form.general.lastname3 : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="8">
          <span class="font-semibold">Fecha de nac.</span>
          <p>{{ showDOB(form)}}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Sexo</span>
          <p>{{ form !== null ? form.general.sex === 1 ? 'Hombre' : 'Mujer' : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="12">
          <span class="font-semibold">Dirección 1</span>
          <p>{{ form !== null ? form.general.address1 : '' }}</p>
        </el-col>
        <el-col :span="12">
          <span class="font-semibold">Dirección 2</span>
          <p>{{ form !== null ? form.general.address2 : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="8">
          <span class="font-semibold">País</span>
          <p>{{ country !== null ? country.name :'' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Departamento</span>
          <p>{{ state !== null ? state.name : '' }}</p>
        </el-col>
        <el-col :span="8">
          <span class="font-semibold">Municipio</span>
          <p>{{ city !== null ? city.name : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-4 mb-2">
        <el-col :span="24" class="border-b">
          <span class="font-semibold">INFORMACION DE DOCUMENTOS</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1" v-for="(document, k) in form.documents" :key="k">
        <el-col :span="9">
          <span class="font-semibold">Tipo de documento</span>
          <p>{{ getDocumentTypeName(document.documentType) }}</p>
        </el-col>
        <el-col :span="7">
          <span class="font-semibold">Número de documento</span>
          <p>{{ document.number }}</p>
        </el-col>
        <el-col :span="4">
          <span class="font-semibold">Expedición</span>
          <p>{{ document.expedition}}</p>
        </el-col>
        <el-col :span="4">
          <span class="font-semibold">Expiración</span>
          <p>{{ document.expiration}}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-4 mb-2">
        <el-col :span="24" class="border-b">
          <span class="font-semibold">INFORMACION DEL PUESTO DE TRABAJO</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="12">
          <span class="font-semibold">Tipo de contrato</span>
          <p>{{ contractType !== null ? contractType.name : '' }}</p>
        </el-col>
        <el-col :span="12">
          <span class="font-semibold">Departamento</span>
          <p>{{ department !== null ? department.name : '' }}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mb-1">
        <el-col :span="6">
          <span class="font-semibold">Tipo de nomina</span>
          <p>{{paysheetType !== null ? paysheetType.name : ''}}</p>
        </el-col>
        <el-col :span="6">
          <span class="font-semibold">Salario inicial</span>
          <p>{{ form.laboral.currentSalary | formatMoney }}</p>
        </el-col>
        <el-col :span="6">
          <span class="font-semibold">Fecha de inicio de contrato</span>
          <p>{{ form.laboral.contractStartDate }}</p>
        </el-col>
        <el-col :span="6">
          <span class="font-semibold">Fecha de fin de contrato</span>
          <p>{{ form.laboral.contractEndDate}}</p>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-5" v-if="!hideButtons">
        <el-col :span="24" class="flex justify-end">
          <el-button size="small" @click="$emit('back')">Atrás</el-button>
          <el-button size="small" type="primary" @click="saveNewContract(contractId)">Guardar</el-button>
          <el-button
            size="small"
            type="success"
            @click="saveNewContractNext(contractId)"
          >Guardar y contratar</el-button>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "NewcontractTabOverview",
  props: ["values", "contractId", "hideButtons"],
  data() {
    return {
      form: {},
      country: null,
      state: null,
      city: null,
      documentTypes: null,
      contractType: null,
      paysheetType: null,
      department: null,
    };
  },
  methods: {
    getDocumentTypeName(id) {
      if (R.isNil(this.documentTypes)) {
        return "";
      } else {
        const document = R.find(R.propEq("id", id))(this.documentTypes);
        return `${document.shortName} - ${document.name}`;
      }
    },
    saveNewContract(contractId) {
      this.$confirm(
        "¿Estás seguro que deseas crear este contrato?",
        "Confirmación",
        {
          confirmButtonText: "Si, guardar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { 
                    employeeUpdate(
                      where: { id: "${contractId}" },
                      data: {
                        contractComplete: 3
                      }
                    ) { id } 
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res;
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha creado el nuevo contrato correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  this.$router.push("/contracts/all");
                  done();
                })
                .catch(console.log)
                .then((alw) => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, guardar";
                });
            } else {
              done();
            }
          },
        }
      );
    },
    saveNewContractNext(id) {
      axios
        .post("/", {
          query: `mutation { toRegisterEmployee(id: "${id}") { id } }`,
        })
        .then((res) => {
          this.$router.push({
            path: "/employees/all",
            query: { id, dialog: true },
          });
        })
        .catch(console.log);
    },
    showDOB(form) {
      return form !== null ? form.general.dob : "";
    },
  },
  created() {
    this.form = this.values;
    axios
      .post("/", {
        query: `{
          country(where: { id: ${this.values.general.country} }) { name }
          state(where: { id: ${this.values.general.state} }) { name }
          city(where: { id: ${this.values.general.city} }) { name }
          documentTypes { id name shortName }
          department(where: { id: ${this.values.laboral.department} }) { id name }
          contractType(where: { id: ${this.values.laboral.contractType} }) { id name }
          paysheetType(where: { id: ${this.values.laboral.paysheetType} }) { id name }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          this.country = data.country;
          this.state = data.state;
          this.city = data.city;
          this.documentTypes = data.documentTypes;
          this.department = data.department;
          this.contractType = data.contractType;
          this.paysheetType = data.paysheetType;
        }
      })
      .catch(console.log);
  },
};
</script>
